import { DefaultService } from '@/services/DefaultService';


export default class AssPrazoPagamentoEmpresaService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    findAllVendas(column, order, page, limit, situacao, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/empresa/assprazopagtoempresa.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idempresa=${idempresa}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findAllAgro(column, order, page, limit, situacao, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/agro/empresa/assprazopagtoempresa.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idempresa=${idempresa}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findAllNaoAssociados(column, order, page, limit, idempresa, isAssociado = false, ...params) {
        return this._http.get( encodeURI(`${this._env}/empresa/assprazopagtoempresa/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idempresa=${idempresa}&isassociado=${isAssociado}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
	}

    find(id) {
		return this._http.get(`${this._env}/ven/empresa/assprazopagtoempresa/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    updateSituacaoVendas(assprazopagtoempresa) {
        return this._http.post(`${this._env}/ven/empresa/assprazopagtoempresa/updatesituacao`, assprazopagtoempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacaoAgro(assprazopagtoempresa) {
        return this._http.post(`${this._env}/agro/empresa/assprazopagtoempresa/updatesituacao`, assprazopagtoempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveVendas(assprazopagtoempresa) {
        return this._http.post(`${this._env}/ven/empresa/assprazopagtoempresa`, assprazopagtoempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveAgro(assprazopagtoempresa) {
        return this._http.post(`${this._env}/agro/empresa/assprazopagtoempresa`, assprazopagtoempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}